import * as React from 'react';
import { DefaultLayout } from '../../../../components/DefaultLayout';
import { Seo } from "../../../../components/Seo";

import { YandexMetrika } from '../../../../components/YandexMetrika';
import { MailRu } from '../../../../components/MailRu';
import { TikTok } from '../../../../components/TikTok';
import { VKPixel } from '../../../../components/VKPixel';
import { AdvCake } from '../../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../../components/HeaderLogoAndTel";
import { FooterMedium } from "../../../../components/FooterMedium";
import { GetCourseWidget } from "../../../../components/GetCourseWidget";

import {
  WhomAdult,
  EducationAdult,
  OfferAdult,
  AttentionAdult,
  ReviewsVideo,
  CostAdult,
  main
} from "../../../../components/LandingTemplates/kuratorskoe_soprovozhdenie";

import * as screen1 from "./styles/screen1.module.scss";
import reviewsData from "./data/reviewsData.json";

const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.screen1__wrapper}>
          <div className={screen1.screen1__titleWrapper}>
            <h1 className={screen1.screen1__title}>Кураторское<br/> сопровождение курса<br/> &laquo;Технологии работы с&nbsp;
              информацией&raquo;</h1>
            <h2 className={screen1.screen1__subtitle}>Под руководством куратора за&nbsp;35&nbsp;дней<br/> освоите навыки
              обработки информации<br/> до&nbsp;уровня автоматического применения</h2>
          </div>
          <div className={screen1.screen1__linkWrapper}>
            <a className={`${screen1.screen1__link} ${main.mainBtn}`} href="#cost" data-target="#course">
              Оставить заявку
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

const TITLE = 'Кураторское сопровождение курса «Технологии работы с информацией»';
const DESCRIPTION = 'Под руководством куратора за 35 дней освоите навыки обработки информации до уровня автоматического применения';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1/>
      <WhomAdult
        video={"https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_vzroslyh/kuratorskoe_soprovozhdenie_tri/video/screencast_tri.mp4"}
        poster={"https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_vzroslyh/kuratorskoe_soprovozhdenie_tri/phone-screencast-tri.png"}
      />
      <EducationAdult/>
      <OfferAdult/>
      <AttentionAdult
        imgSrc={"https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_vzroslyh/kuratorskoe_soprovozhdenie_tri/iphone-hand.png"}
      />
      <ReviewsVideo
        courseName={"Технологии работы с\u00A0информацией"}
        vidSrc={"https://www.youtube.com/embed/0dayyHYEbuY"}
        data={reviewsData}
      />
      <CostAdult
        widget={<GetCourseWidget hash={'3141150ee98334efced5718a052704ae36feff43'} id={'868443'}/>}
        imgSrc={"https://fs.advance.ru/landing-pages/razvivayushie_kursy/dlya_vzroslyh/kuratorskoe_soprovozhdenie_tri/iphone-price.png"}
      />
    </main>

    <FooterMedium/>
  </DefaultLayout>
);

export default Page;
